module.exports = __webpack_public_path__ + "static/img/tst2-04.3962b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-04.jpg
// module id = kQVk
// module chunks = 1